/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AgentEditDto {
  /**
   * ID Agenta
   * @format uuid
   */
  agentId: string;
  /**
   * Imię agenta
   * @example "Jan"
   */
  firstName: string;
  /**
   * Nazwisko agenta
   * @example "Kowalski"
   */
  lastName: string;
  /**
   * Email agenta
   * @example "test@gmail.com"
   */
  email: string;
  /**
   * Numer telefonu agenta
   * @example "123456789"
   */
  phoneNumber: string;
  /**
   * Dostępny pakiet SMS
   * @format int32
   * @example 100
   */
  smsPackage: number;
}

export interface AgentEditPasswordDto {
  /**
   * Id agenta
   * @format uuid
   */
  agentId: string;
  /**
   * Hasło
   * @example "fvetf$V4tdav"
   */
  password: string;
  /**
   * Potwierdzenie hasła
   * @example "fvetf$V4tdav"
   */
  confirmPassword: string;
}

export interface AgentCreateDto {
  /**
   * Imię agenta
   * @example "Jan"
   */
  firstName: string;
  /**
   * Nazwisko agenta
   * @example "Kowalski"
   */
  lastName: string;
  /**
   * Email agenta
   * @example "email@gmail.com"
   */
  email: string;
  /**
   * Numer telefonu
   * @example "123456789"
   */
  phoneNumber: string;
  /**
   * Hasło
   * @example "awcasfRV#%vv4tad"
   */
  password: string;
  /**
   * Potwierdzenie hasła
   * @example "awcasfRV#%vv4tad"
   */
  confirmPassword: string;
  /**
   * Dostępny pakiet SMS
   * @format int32
   * @example 100
   */
  smsPackage: number;
}

export interface BlockageNotificationDto {
  /**
   * Id ogłoszenia
   * @format int64
   * @example 1
   */
  advertisementId: number;
  module: Module;
}

/**
 * Moduł
 * @example "SALE_FLAT"
 */
export enum Module {
  SALE_FLAT = "SALE_FLAT",
  SALE_HOUSE = "SALE_HOUSE",
  SALE_PLOT = "SALE_PLOT",
  SALE_OTHER = "SALE_OTHER",
  RENT_FLAT = "RENT_FLAT",
  RENT_HOUSE = "RENT_HOUSE",
  RENT_PLOT = "RENT_PLOT",
  RENT_OTHER = "RENT_OTHER",
  BAILIFF_NOTICE = "BAILIFF_NOTICE",
  AUCTION = "AUCTION",
  TENDER = "TENDER",
  COOPERATIVE = "COOPERATIVE",
}

export interface UnblockAdvertisementDto {
  /**
   * Id ogłoszenia
   * @format int64
   * @example 1
   */
  advertisementId: number;
  module: Module;
}

export interface BlockageAdvertisementDto {
  /**
   * Id ogłoszenia
   * @format int64
   * @example 1
   */
  advertisementId: number;
  module: Module;
  /**
   * Czas blokady w dniach
   * @format int32
   * @example 14
   */
  days: number;
}

export interface PermanentBlockAdvertisementDto {
  /**
   * Id ogłoszenia
   * @format int64
   * @example 1
   */
  advertisementId: number;
  module: Module;
}

export interface OrganizationAddDto {
  /**
   * Email
   * @example "test@gmail.com"
   */
  email: string;
  /**
   * Nazwa organizacji
   * @example "Organizacja"
   */
  name: string;
  /**
   * Opis organizacji
   * @example "Testowy opis organizacji"
   */
  description?: string;
  /**
   * Liczba wszystkich dostępujących SMS-ów
   * @format int32
   * @example 100
   */
  totalSmsNumber: number;
  /**
   * @format int32
   * @example 10
   */
  "Liczba wszystkich dostępnych nowych kont": number;
  /**
   * @format int32
   * @example 100
   */
  "Tokeny AI dla organizacji": number;
}

export interface AgencyDashboardDto {
  /**
   * Nazwa organizacji
   * @example "Testowa organizacja"
   */
  agencyName: string;
  /**
   * Liczba agentów i dostępnych nowych kont
   * @example "1 aktywnych / 10 dostępnych"
   */
  numberOfAgents: string;
  /**
   * Data końca subskrypcji
   * @format date-time
   */
  packageDate: string;
  /**
   * Liczba nie przypisanych SMS do kont użytkowników
   * @format int32
   * @example 250
   */
  totalSmsAvailableToNewAccounts: number;
  /**
   * Liczba wykorzystanych sms organizacji i całkowita liczba SMS w organizacji
   * @example "100  wykorzystanych / 1000  dostępnych przypisanych do użytkowników"
   */
  smsPackage: string;
  /**
   * Liczba wszystkich użytych SMS w danym miesiącu
   * @format int32
   * @example 100
   */
  totalSmsUsed: number;
  /**
   * Liczba dostępnych SMS w organizacji
   * @format int32
   * @example 100
   */
  totalSmsNumber: number;
  /**
   * Istniejące aktywne konta
   * @format int32
   * @example 3
   */
  existedAccountNumber: number;
  /**
   * Maksymalna liczba dostępnych aktywnych kont
   * @format int32
   * @example 5
   */
  totalAccountNumber: number;
  /**
   * Liczba sms przypisana do admina
   * @format int32
   * @example 100
   */
  adminSmsPackage: number;
  agents?: AgentDetailDto[];
}

export interface AgentDetailDto {
  /**
   * ID agenta
   * @format uuid
   */
  agentId: string;
  /**
   * Imię agenta
   * @example "Jan"
   */
  firstName: string;
  /**
   * Nazwisko agenta
   * @example "Kowalski"
   */
  lastName: string;
  /**
   * Email agenta, dane do logowania
   * @example "test@gmail.com"
   */
  email: string;
  /**
   * Miesięczny pakiet SMS do wykorzystania
   * @format int32
   * @example 100
   */
  smsPackage: number;
  /**
   * Data ostatniego logowania
   * @format date-time
   */
  lastLogin?: string;
  /**
   * Status aktywacji konta
   * @example true
   */
  activationStatus?: boolean;
  organizationRole: OrganizationRole;
}

/**
 * Ranga w organizacji
 * @example "ORGANIZATION_USER"
 */
export enum OrganizationRole {
  ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
  ORGANIZATION_AGENT = "ORGANIZATION_AGENT",
}

export interface AgentEditDetailDto {
  /**
   * Id agenta
   * @format uuid
   */
  agentId: string;
  /**
   * Imię agenta
   * @example "Jan"
   */
  firstName: string;
  /**
   * Nazwisko agenta
   * @example "Kowalski"
   */
  lastName: string;
  /**
   * Nazwisko agenta
   * @example "test@gmail.com"
   */
  email: string;
  /**
   * Numer telefonu agenta
   * @example "123456789"
   */
  phoneNumber: string;
  /**
   * Dostępny pakiet sms dla agenta
   * @format int32
   * @example 100
   */
  smsPackage: number;
  organizationRole: OrganizationRole;
}

export interface BlockageInfoDto {
  /**
   * Id oryginalnego ogłoszenia zablokowanego
   * Id oryginalnego ogłoszenia mogą się zmienić podczas działania aplikacji
   * @format int64
   * @example 1
   */
  originalAdvertisementId: number;
  module: Module;
  /**
   * Czas blokady w dniach
   * @format int32
   * @example 14
   */
  days: number;
  /**
   * Data końca blokady
   * @format date-time
   */
  blockedDate: string;
  /**
   * Nazwa użytkownika blokującego ogłoszenie
   * @example "Jan Kowalski"
   */
  userName: string;
  /**
   * Czy blokada jest stała
   * @example true
   */
  permanentlyBlocked: boolean;
  /**
   * Czy jest ustawiona blokada
   * @example true
   */
  notificationStatus: boolean;
  myBlockage?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  v2 = {
    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name EditEmployee
     * @summary Edycja kont agentów
     * @request PUT:/v2/broker/manage/edit/employee
     * @secure
     */
    editEmployee: (data: AgentEditDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/broker/manage/edit/employee`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name EditEmployeePassword
     * @summary Edycja hasła dla konta agenta
     * @request PUT:/v2/broker/manage/edit/employee-password
     * @secure
     */
    editEmployeePassword: (data: AgentEditPasswordDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/broker/manage/edit/employee-password`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name EditAdminSmsPackage
     * @summary Edycja pakietu SMS dla admina
     * @request PUT:/v2/broker/manage/edit/admin/sms-package
     * @secure
     */
    editAdminSmsPackage: (
      query?: {
        /**
         * @format int32
         * @default 100
         */
        smsPackage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/broker/manage/edit/admin/sms-package`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name EditAccountStatus
     * @summary Edycja statusu aktywacji konta
     * @request PUT:/v2/broker/manage/edit/account-status
     * @secure
     */
    editAccountStatus: (
      query: {
        /** @default true */
        activationStatus?: boolean;
        /** @format uuid */
        agentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/broker/manage/edit/account-status`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name CreateEmployee
     * @summary Tworzenie nowych kont dla agentów
     * @request POST:/v2/broker/manage/create/employee
     * @secure
     */
    createEmployee: (data: AgentCreateDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/broker/manage/create/employee`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia do zablokowanych ogłoszeń
     * @name CreateAdvertisementNotification
     * @summary Dodanie ogłoszenia do powiadomienia o odblokowaniu
     * @request POST:/v2/broker/advertisement/notification/add
     * @secure
     */
    createAdvertisementNotification: (data: BlockageNotificationDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/broker/advertisement/notification/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blokowanie ogłoszeń
     * @name BlockageAdvertisement
     * @summary Odblokowywanie pojedynczego ogłoszenia
     * @request POST:/v2/broker/advertisement/blockage/unblock
     * @secure
     */
    blockageAdvertisement: (data: UnblockAdvertisementDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/broker/advertisement/blockage/unblock`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blokowanie ogłoszeń
     * @name BlockageAdvertisement1
     * @summary Blokowanie ogłoszeń na dany okres czasowy
     * @request POST:/v2/broker/advertisement/blockage/temporary
     * @secure
     */
    blockageAdvertisement1: (data: BlockageAdvertisementDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/broker/advertisement/blockage/temporary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blokowanie ogłoszeń
     * @name BlockageAdvertisement2
     * @summary Blokowanie ogłoszeń na stałe
     * @request POST:/v2/broker/advertisement/blockage/permanent
     * @secure
     */
    blockageAdvertisement2: (data: PermanentBlockAdvertisementDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/broker/advertisement/blockage/permanent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-controller
     * @name AddOrganization
     * @request POST:/v2/broker/admin/organization/add
     * @secure
     */
    addOrganization: (data: OrganizationAddDto, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/v2/broker/admin/organization/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name EmployeesList
     * @summary Pobieranie listy i podstawowych informacji o agentach i organizacji
     * @request GET:/v2/broker/manage/employees-list
     * @secure
     */
    employeesList: (params: RequestParams = {}) =>
      this.http.request<AgencyDashboardDto, object>({
        path: `/v2/broker/manage/employees-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name EmployeesEditDetail
     * @summary Pobieranie danych agenta do edycji
     * @request GET:/v2/broker/manage/edit-detail/employee
     * @secure
     */
    employeesEditDetail: (
      query: {
        /** @format uuid */
        agentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AgentEditDetailDto, object>({
        path: `/v2/broker/manage/edit-detail/employee`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blokowanie ogłoszeń
     * @name BlockageInfo
     * @summary Wszystkie informacji o blokadzie
     * @request GET:/v2/broker/advertisement/blockage/info
     * @secure
     */
    blockageInfo: (
      query: {
        /** @format int64 */
        advertisementId: number;
        module: Module;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BlockageInfoDto, object>({
        path: `/v2/broker/advertisement/blockage/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pracownikami
     * @name DeleteAccount
     * @summary Usunięcie konta agenta
     * @request DELETE:/v2/broker/manage/delete/account
     * @secure
     */
    deleteAccount: (
      query: {
        /** @format uuid */
        agentUUID: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/broker/manage/delete/account`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia do zablokowanych ogłoszeń
     * @name DeleteAdvertisementNotification
     * @summary Usunięcie powiadomienia do ogłoszenia
     * @request DELETE:/v2/broker/advertisement/notification/delete
     * @secure
     */
    deleteAdvertisementNotification: (
      query: {
        /** @format int64 */
        advertisementId: number;
        module: Module;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/broker/advertisement/notification/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
